<section>
    <div class="dashboard_bred_crumb">
        <ul>
            <li><a [routerLink]="['/profile/course-listing']" routerLinkActive="active-link">Course Listing</a></li>
            <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
            <li><a routerLinkActive="active-link">Registered-Users</a></li>
        </ul>
    </div>
</section>



<section class="master_add_sec" *ngIf="selectedCourse">
    <mat-card class="job-card" fxLayout="column" fxLayoutGap="16px">


        <!-- Row: Avatar + Content -->
        <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start">
            <!-- Avatar -->
            <div class="avatar">
                <img *ngIf="selectedCourse?.presented_by_image?.url" src="{{selectedCourse?.presented_by_image?.url}}"
                    alt="Avatar" loading="lazy" />
            </div>

            <div fxFlex class="content-box" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px">
                <!-- Top Row -->
                <div fxLayout="row" fxLayoutAlign="space-between center" class="top-row">
                    <div class="title" *ngIf="selectedCourse.course_name || selectedCourse.created_at">
                        <strong class="title_head" *ngIf="selectedCourse.course_name">
                            {{ selectedCourse.course_name }}
                        </strong>
                    </div>
                    <div>
                        <span class="date" *ngIf="selectedCourse.created_at">
                            Posted on : {{ selectedCourse.created_at | date:'dd-MM-yyyy' }}
                        </span>
                    </div>
                </div>

                <!-- Course Name -->
                <div class="company-name" *ngIf="selectedCourse.presented_by_name">
                    {{ selectedCourse.presented_by_name }}

                </div>

                <!-- Chips + Applicants -->
                <div fxLayout="row" fxLayoutAlign="space-between center" class="chip-row">
                    <mat-chip-list class="chip-list" aria-label="Job Types" *ngIf="selectedCourse.type">
                        <mat-chip>{{ selectedCourse.type }}</mat-chip>
                    </mat-chip-list>
                </div>
            </div>
        </div>

        <div class="inner-divider"></div>
    </mat-card>



    <!-- register - users -->
    <div infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="200" [scrollWindow]="true"
        (scrolled)="onScroll()">

        <div class="applicants-container">

            <!-- Loader when no users (initial) -->
            <div *ngIf="loading && registeredUsers.length === 0" class="loading-spinner" fxLayout="row"
                fxLayoutAlign="center center">
                <img src="../../../../../assets/images2/loader.gif" alt="Loading..." loading="lazy" width="120px" />
            </div>

            <!-- User cards (no wrapper div) -->
            <div *ngIf="registeredUsers.length > 0; else noUsers">

                <div class="applicant-card" *ngFor="let user of registeredUsers">

                    <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start">

                        <div class="avatar">
                            <img *ngIf="user?.directories_supplier?.dental_supplier"
                                src="{{user?.directories_supplier?.dental_supplier?.logo?.url}}" loading="lazy" />

                            <img *ngIf="user?.directories_practice?.dental_practice"
                                src="{{user?.directories_practice?.dental_practice?.logo?.url}}" loading="lazy" />

                            <img *ngIf="user?.directories_professional?.dental_professional"
                                src="{{user?.directories_professional?.dental_professional?.profile_image?.url}}"
                                loading="lazy" />

                            <img *ngIf="!user?.directories_supplier?.dental_supplier && !user?.directories_practice?.dental_practice && !user?.directories_professional?.dental_professional"
                                src="../../../../../assets/images/logo.svg" />

                        </div>

                        <div fxFlex class="content-box" fxLayout="column" fxLayoutAlign="start stretch"
                            fxLayoutGap="8px">
                            <!-- Name -->
                            <div class="applicant-name" *ngIf="user.first_name || user.last_name">
                                {{ user.first_name }} {{ user.last_name }}
                            </div>

                            <!-- Email -->
                            <div class="applicant-info" *ngIf="user.email">
                                <mat-icon class="info-icon">email</mat-icon>
                                <span class="info-text">{{ user.email }}</span>
                            </div>

                            <!-- Phone -->
                            <div class="applicant-info" *ngIf="user.phone_number">
                                <mat-icon class="info-icon">phone</mat-icon>
                                <span class="info-text">{{ user.phone_number }}</span>
                            </div>

                            <!-- Description / Job -->
                            <div class="applicant-description" *ngIf="user.description">
                                <h4 class="applicant-description-title">Description</h4>
                                {{ user.description }}
                            </div>
                        </div>




                    </div>



                </div>

            </div>

            <!-- Loader for infinite scroll (bottom) -->
            <div *ngIf="loading && registeredUsers.length > 0" class="loading-more" fxLayout="row"
                fxLayoutAlign="center center">
                <img src="../../../../../assets/images2/loader.gif" alt="Loading more..." loading="lazy" width="80px" />
            </div>

        </div>

        <!-- No users message -->

        <ng-template #noUsers>
            <div class="no-users">
                No registered users found.
            </div>
        </ng-template>

        <!-- 
<ng-template #noUsers>
            <div style="text-align: center;">
                <h4 class="no_state_heading"> No registered users found.</h4>
            </div>
        </ng-template>  -->
    </div>







</section>